import React, { Component } from "react";

class PainelLittle extends Component {
  render() {
    return (
      <div className="panel panel-default">
        {this.props.title ? (
          <div className="panel-heading font-bold">{this.props.title}</div>
        ) : null}
        <div className="panel-body panel-body-little">{this.props.children}</div>
      </div>
    );
  }
}

export default PainelLittle;



// WEBPACK FOOTER //
// ./src/components/Painel/painellittle.js